import DefaultLayout from '@/layouts/default/DefaultLayout'
import LoginView from '@/views/auth/LoginView'
import RegisterView from '@/views/auth/RegisterView'
import EmailConfirmationView from '@/views/auth/EmailConfirmationView';
import ResetPasswordView from '@/views/auth/ResetPasswordView';
import RequestResetPasswordView from '@/views/auth/RequestResetPasswordView';

export default [
    {
        path: '/auth',
        component: DefaultLayout,
        meta: {
            middleware: [ 'guest' ]
        },
        children: [
            {
                name: 'auth.login',
                path: 'login',
                component: LoginView
            },
            {
                name: 'auth.register',
                path: 'register',
                component: RegisterView
            },
            {
                name: 'auth.email-confirmation',
                path: 'email-confirmation',
                component: EmailConfirmationView
            },
            {
                name: 'auth.request-reset-password',
                path: 'request-reset-password',
                component: RequestResetPasswordView
            },
        ]
        
    },
    {
        path: '/reset-password',
        component: DefaultLayout,
        meta: {
            middleware: [ 'guest' ]
        },
        children: [
            {
                name: 'auth.reset-password',
                path: '',
                component: ResetPasswordView
            }
        ]
    }
]